import { BaseInterior } from './BaseInterior';
import { socketManager } from '../socket/SocketManager';

export class HouseChoiceInterior extends BaseInterior {
  render(): void {
    this.drawRoom(0x4a3a2a, 0x6b5b4b);
    this.addExitButton();
    this.addTitle(this.building.name);

    const { width, height } = this.scene.scale;
    const cx = width / 2;

    this.addLabel(cx, 120, 'Ce batiment n\'a pas encore de role.', '#ff9800', '16px').setOrigin(0.5);
    this.addLabel(cx, 150, 'Choisissez son utilisation:', '#aaaaaa', '14px').setOrigin(0.5);

    // Deal point choice
    this.addButton(cx, 220, '[ Installer un Point de Deal ]', '#4caf50', () => {
      socketManager.sendAction('ASSIGN_BUILDING_ROLE', {
        buildingId: this.building.id,
        role: 'DEAL_POINT',
      });
      this.refreshAfterAction();
    });

    this.addLabel(cx, 255, 'Vendez de la drogue aux clients', '#888888', '11px').setOrigin(0.5);

    // Stash choice
    this.addButton(cx, 310, '[ Utiliser comme Planque ]', '#3a6bc4', () => {
      socketManager.sendAction('ASSIGN_BUILDING_ROLE', {
        buildingId: this.building.id,
        role: 'STASH',
      });
      this.refreshAfterAction();
    });

    this.addLabel(cx, 345, 'Stockez drogue et marchandise', '#888888', '11px').setOrigin(0.5);
  }

  private refreshAfterAction(): void {
    socketManager.onceActionResult(() => {
      socketManager.sendAction('ENTER_BUILDING', { buildingId: this.building.id });
    });
  }

  bindEvents(): void {}
}
